class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.toast = document.getElementById('savia-cart-toast');

    /* SAVIA: sacar el toast del cart drawer */
    if (this.toast && this.toast.parentElement !== document.body) {
      document.body.appendChild(this.toast);
    }

    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.toastTimer = null;

    if (this.notification) {
      this.notification.addEventListener(
        'keyup',
        (evt) => evt.code === 'Escape' && this.close()
      );
    }

    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    /* No abrir la notificación original de Dawn */
    if (this.notification) {
      this.notification.classList.remove('animate', 'active');
      this.notification.setAttribute('aria-hidden', 'true');
    }

    this.showSaviaToast();
    this.dispatchCartViewEvent();
  }

  showSaviaToast() {
    if (!this.toast) {
      this.toast = document.getElementById('savia-cart-toast');
    }

    if (!this.toast) return;

    /* Asegurar que el toast esté directamente dentro de BODY */
    if (this.toast.parentElement !== document.body) {
      document.body.appendChild(this.toast);
    }

    clearTimeout(this.toastTimer);

    this.toast.classList.add('savia-show');

    this.toastTimer = setTimeout(() => {
      this.toast.classList.remove('savia-show');
    }, 1200);
  }

  async dispatchCartViewEvent() {
    const { CartViewEvent } = window.StandardEvents || {};
    if (!CartViewEvent) return;

    try {
      const response = await fetch(`${routes.cart_url}.json`);
      const cart = await response.json();

      if (!cart?.currency) return;

      this.dispatchEvent(
        new CartViewEvent({
          context: 'dialog',
          cart: CartViewEvent.createCartFromAjaxResponse(cart),
        })
      );
    } catch (e) {
      /* Evento informativo: no interrumpir carrito */
    }
  }

  close() {
    clearTimeout(this.toastTimer);

    if (this.toast) {
      this.toast.classList.remove('savia-show');
    }

    if (this.notification) {
      this.notification.classList.remove('animate', 'active');
      this.notification.setAttribute('aria-hidden', 'true');
    }

    document.body.removeEventListener('click', this.onBodyClick);

    if (typeof removeTrapFocus === 'function') {
      removeTrapFocus(this.activeElement);
    }
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;

    this.getSectionsToRender().forEach((section) => {
      const target = document.getElementById(section.id);

      if (!target) return;

      const sectionHtml = parsedState.sections?.[section.id];

      if (!sectionHtml) return;

      const newHtml = this.getSectionInnerHTML(
        sectionHtml,
        section.selector
      );

      if (newHtml !== null) {
        target.innerHTML = newHtml;
      }
    });

    if (this.header) {
      this.header.reveal();
    }

    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const parsedDocument =
      new DOMParser().parseFromString(html, 'text/html');

    const element = parsedDocument.querySelector(selector);

    return element ? element.innerHTML : null;
  }

  handleBodyClick(evt) {
    const target = evt.target;

    if (
      this.toast &&
      target !== this.toast &&
      !target.closest('#savia-cart-toast')
    ) {
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);